import React from 'react'


const UploadImage = ({value}) => {
    return <img src={value} style={{ width: '100%' }} alt="" />
}

export default UploadImage